import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";
import { PublisherLogoutControl } from "./PublisherLogoutControl";
import { SideNavigation } from "./SideNavigation";

/*
 * OPENAPPCART LOCKED SHARED SHELL CHROME
 * Desktop (≥85rem): logo + right navigation — FINAL approved geometry.
 * Styles: Frontend/src/styles/shared-shell.css
 *
 * Narrow/mobile only: masthead + menu icon represent the SAME navigation.
 * Must not alter desktop rendering.
 */

export function AppShellChrome() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const shell = document.querySelector(".oac-app-shell--master-shell");
    shell?.classList.toggle("oac-app-shell--mobile-nav-open", mobileMenuOpen);

    return () => {
      shell?.classList.remove("oac-app-shell--mobile-nav-open");
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (!mobileMenuOpen) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);

  return (
    <>
      <header className="oac-public-mobile-masthead">
        <BrandLogo className="oac-brand oac-public-mobile-masthead__brand" />
        <button
          aria-controls="oac-public-primary-navigation"
          aria-expanded={mobileMenuOpen}
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          className="oac-public-mobile-menu-button"
          onClick={() => setMobileMenuOpen((open) => !open)}
          type="button"
        >
          <span aria-hidden="true" className="oac-public-mobile-menu-button__lines">
            <span />
            <span />
            <span />
          </span>
        </button>
      </header>

      <header
        className={[
          "oac-fixed-brand",
          "oac-site-header",
          "oac-public-layout__header",
        ].join(" ")}
      >
        <BrandLogo className="oac-brand oac-public-layout__brand" />
      </header>

      <button
        aria-hidden={!mobileMenuOpen}
        aria-label="Close menu"
        className={[
          "oac-public-navigation-backdrop",
          mobileMenuOpen ? "oac-public-navigation-backdrop--open" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => setMobileMenuOpen(false)}
        tabIndex={mobileMenuOpen ? 0 : -1}
        type="button"
      />

      <aside
        className={[
          "oac-fixed-navigation",
          "oac-master-navigation-aside",
          mobileMenuOpen ? "oac-fixed-navigation--mobile-open" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        id="oac-public-primary-navigation"
      >
        <PublisherLogoutControl onLogout={() => setMobileMenuOpen(false)} />
        <SideNavigation onNavigate={() => setMobileMenuOpen(false)} />
      </aside>
    </>
  );
}
